import React from 'react';

export interface FadedBounceProps {
  children: JSX.Element | JSX.Element[];
  delay?: number;
  enabled: boolean;
}

export default function FadedBounce({ children, delay = 0, enabled }: FadedBounceProps): JSX.Element {
  const className = 'faded-bounce';

  return (
    <div className={className}>
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          className: `faded-bounce-content ${child.props.className ? child.props.className : ''} ${
            enabled === true ? `${className}-in` : enabled === false ? `${className}-out` : ''
          }`,
          style: Object.assign({}, child.props.style, {
            animationDelay: `${delay}ms`,
          }),
        })
      )}
    </div>
  );
}
